module.exports = __webpack_public_path__ + "img/incidentInfoBlack.b72d6f7c.svg";